module.exports = __webpack_public_path__ + "media/images/emblems/Epsach-coat_of_arms-8d319a611c843243075bcb3c93120abb.svg";